module.exports = __webpack_public_path__ + "static/media/patrol_1.d2ef11ed.png";